import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'

/**
 * <Wait message />
 */

class Wait extends Component {

	render() {
		return <Dialog
			open = {true}
			scroll = "body"
		>
			<DialogTitle>
				{this.props.message}
			</DialogTitle>
		</Dialog>
	}

}

export default Wait
